import { BasePaginatedUseCase } from "../../../../../common/domain/useCases/base_paginated_use_case";
import { IGetAllControlePatrimonioArquivoUseCase } from "../../../presentation/useCases/read/get_all_controle_patrimonio_arquivo_use_case";
import { ControlePatrimonioArquivoLista } from "../../models/controle_patrimonio_arquivo_lista";
import { IControlePatrimonioRepository } from "../../repositories/ControledePatrimonio";

/**
 * GetAllControlePatrimonioArquivoUseCase
 */

export class GetAllControlePatrimonioArquivoUseCase
  extends BasePaginatedUseCase<ControlePatrimonioArquivoLista>
  implements IGetAllControlePatrimonioArquivoUseCase {
  constructor(private readonly repository: IControlePatrimonioRepository) {
    super();
  }

  async getAllControlePatrimonioArquivo(
    idMaquinaEquip: number | undefined,
    page: number,
    rowsPerPage: number,
  ): Promise<void> {
    if (idMaquinaEquip === undefined || idMaquinaEquip === null) throw new Error("Falha ao obter ID de Máquina/Equipamento.");

    const response = await this.repository.getAllControlePatrimonioArquivo(
      idMaquinaEquip,
      page,
      rowsPerPage,
    );

    this._items = response.items;
    this._totalPages = response.totalPages;
    this._totalItems = response.totalItems;
    this._currentPage = response.currentPage;
    this._pageSize = response.pageSize;
  }
}
